import React from 'react';
import { Link } from 'react-router-dom';

import logo from '../../../public/nex.png';

import NavigationView from './NavigationView';

export default class HeaderView extends React.Component {
  render() {
    return (
      <header className="navigation" role="banner">
        <div className="navigation-wrapper">
          <Link to="/" className="logo">
            <img src={logo} alt="Logo" />
          </Link>
          <NavigationView />
        </div>
      </header>
    );
  }
}
